
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 2.67A13.33 13.33 0 112.67 16 13.35 13.35 0 0116 2.67zM16 0a16 16 0 1016 16A16 16 0 0016 0zm8 21.46L18.46 16l5.46-5.52L21.46 8 16 13.55l-5.56-5.47L8 10.52 13.55 16l-5.47 5.56L10.52 24 16 18.45l5.53 5.47z"}})])
          )
        }
      }
    